S.mediastage =
    {
        elements: {
            $header: null,
        },

        init()
        {},

        hideHeader()
        {
            if ($(window).width() > 425)
            {
                if (this.elements.$header)
                {
                    this.elements.$header.hide();
                }
            }
        },

        showHeader()
        {
            if (this.elements.$header)
            {
                this.elements.$header.show();
            }
        },
    };
